import { Component, effect, Inject, input, PLATFORM_ID } from '@angular/core';
import {
  WagtailAccordionRendererInterface,
  WagtailPageContentElementInterface
} from "@gea-waldviertler-website/gea-models";
import { isPlatformBrowser } from "@angular/common";

@Component({
    selector: 'wagtail-page-element-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    standalone: false
})
export class WagtailAccordionComponent {

  definition = input<WagtailPageContentElementInterface<WagtailAccordionRendererInterface> | undefined>(undefined)

  content?: WagtailAccordionRendererInterface

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    effect(() => {
      const d = this.definition()
      if (d && isPlatformBrowser(this.platformId)) {
        this.content = d.value
      }
    })
  }
}
